import { Component, OnInit } from '@angular/core';
import { Subscriber } from 'rxjs';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-privacy',
  templateUrl: './show-privacy.component.html',
  styleUrls: ['./show-privacy.component.scss'],
})
export class ShowPrivacyComponent implements OnInit {
  personal: string;
  sub = new Subscriber();

  constructor(private db: DbService) {}

  ngOnInit() {
    const personal = this.db.doc$('admin/admin').subscribe(({ personal }) => {
      this.personal = personal;
    });
    this.sub.add(personal);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
